import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { TokenHandlerComponent } from './token-handler.component';

@NgModule({
    declarations: [
        TokenHandlerComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        MatProgressSpinnerModule,
    ],
    exports: [
        TokenHandlerComponent,
    ]
})
export class TokenHandlerModule { }
